import { useEffect, useState } from 'react';
import {
  fetchRecentlyViewed,
  getRecentlyViewed,
} from '@javascript/vehicle_product/helper/recentVehiclesHelper';
import type { Vehicle } from '@javascript/types/Vehicle';

type RecentlyViewedVehiclesProps = {
  showVehicles: boolean;
};

type RecentlyViewedVehicleCardProps = {
  recentlyViewed: Vehicle[];
};

const RecentlyViewedVehicleCard = ({
  recentlyViewed,
}: RecentlyViewedVehicleCardProps) => {
  return (
    <>
      {recentlyViewed.map((vehicle) => (
        <a
          className="ac-autocomplete__recently-viewed ch-ba--1 ch-bc--grey-3 ch-mb--2 ch-pa--2 ch-rounded--md ch-text-decoration--none"
          href={`${vehicle.url}`}
          key={vehicle.stockReference}
        >
          {vehicle.thumbnails[0] ? (
            <img
              alt={vehicle.title.name}
              className="ch-rounded--sm"
              src={vehicle.thumbnails[0]}
            />
          ) : (
            <div className="image-placeholder ch-rounded--sm" />
          )}
          <div className="ac-autocomplete__recently-viewed--vehicle ch-display--flex ch-flex-flow--column-nowrap ch-text--left ch-ml--2 ch-align-items--center ch-fs--2 ch-fw--500 ch-mb--1 ch-color--ac-black">
            <span className="ac-autocomplete__recently-viewed--vehicle--title ch-width--12">
              {vehicle.title.name}
            </span>
            <span className="ch-fs--1 ch-fw--500 ch-display--block ch-text--ellipsis ch-color--grey-6 ch-width--12">
              {vehicle.title.variant}
            </span>
          </div>
        </a>
      ))}
    </>
  );
};

const RecentlyViewedVehicles = ({
  showVehicles,
}: RecentlyViewedVehiclesProps) => {
  const [recentlyViewed, setRecentlyViewed] = useState<Vehicle[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const skeletonCount =
    getRecentlyViewed().length > 4 ? 4 : getRecentlyViewed().length;

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);

      const viewed = await fetchRecentlyViewed();
      setRecentlyViewed(
        viewed && viewed.body ? viewed.body.slice(0, skeletonCount) : []
      );
      setIsLoading(false);
    };
    fetchData();
  }, []);

  if (!showVehicles || (!isLoading && recentlyViewed.length === 0)) return null;

  return (
    <>
      <hr className="ch-mb--4 ch-mt--3 ch-mh--1 sm:ch-mh--3 ch-bg--grey-3"></hr>
      <h3 className="ch-mb--2 ch-fs--3 sm:ch-fs--4 ch-ph--1 sm:ch-ph--3">
        Recently viewed
      </h3>
      {isLoading ? (
        <div className="ch-pl--1 ch-pr--3 ch-overflow--auto ch-display--flex sm:ch-flex-flow--row-wrap">
          {Array.from({ length: skeletonCount }).map((_, index) => (
            <div
              className="ch-width--12 ch-mr--2 ch-mb--2 ch-ph--2 ch-pv--3 ch-rounded--md ch-skeleton skeleton--result-card"
              key={index}
            ></div>
          ))}
        </div>
      ) : (
        recentlyViewed.length > 0 && (
          <>
            <div className="ch-pl--1 ch-pr--3 ch-overflow--auto ch-display--flex sm:ch-flex-flow--row-wrap">
              <RecentlyViewedVehicleCard recentlyViewed={recentlyViewed} />
            </div>
          </>
        )
      )}
    </>
  );
};

export default RecentlyViewedVehicles;
